import axios from 'axios'

const url = process.env.VUE_APP_URL_API_AIDESFI
const token = process.env.VUE_APP_TOKEN_API_AIDESFI

export default {
  postReportError (formDatas) {
    formDatas.type = formDatas.type.value

    return axios.post(url + 'report-error', formDatas, {
      headers: {
        'X-AUTH-TOKEN': token
      }
    })
  }
}
